import loader from "../assets/imgs/rhombus.gif"
const AnimatedLoader = () => {
    return <img src={loader} alt=""/>
}

export default AnimatedLoader